import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";

import FavoritesContainer from "../components/Favorites";
import TabsContainer from "../components/TabHomeComponent";
import NavBar from "../components/Navbar";

const saludo = () => {
  let actualDate = new Date();
  const actualHour = actualDate.getHours();

  switch (true) {
    case actualHour >= 0 && actualHour < 12: {
      return "Buenos días";
    }
    case actualHour >= 12 && actualHour < 19: {
      return "Buenas tardes";
    }
    case actualHour >= 19 && actualHour <= 23: {
      return "Buenas noches";
    }

    default: {
      return "Bienvenido de vuelta";
    }
  }
};
const name = (userName) => {
  let result = "";

  if (userName) {
    let nameCleaned = userName.replace(/\s\s+/g, " ");

    let namediv = nameCleaned.split(" ");

    namediv.pop();

    result = namediv.join(" ") || "";
  }

  return result;
};

// const userName = useSelector((state) => getName(state.auth.token));
const Home = () => {
  return (
    <>
      <NavBar />
      <Grid
        container
        direction="column"
        justify="flex-start"
        spacing={0}
        style={{
          minHeight: "calc(100% - 64px)",
          paddingLeft: "10vw",
          paddingTop: 88,
          paddingRight: "10vw",
          maxWidth: "100vw",
        }}
      >
        <Grid container direction="row" spacing={2}>
          <Grid item>
            <Typography align="left" color="primary" variant="h5">
              {saludo()}
            </Typography>
          </Grid>
          <Grid item>
            {/* <Typography align="left" color="textSecondary" variant="h6">
              {name(userName)}
            </Typography> */}
          </Grid>
        </Grid>
        <FavoritesContainer />
        <TabsContainer />
      </Grid>
    </>
  );
};

export default Home;
